export const MEDIA_PROPS_ACCESSOR = 'media';
export const MEDIA_PROPS_EDITORDEF = {
  loadDefinition: 'default'
};